import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import { selectionBookingRefundeds, selectionRefunded } from '../selects'
import { refundedService } from '@/services/refunded'

export const getRefundedCountQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.refunded.count(),
    queryFn: ({ signal }) => refundedService.count({ signal }),
  })

export const getRefundedsQueryOptions = () =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.refunded.list(),
    queryFn: ({ pageParam }) => refundedService.list({ page: pageParam }),
    getNextPageParam: (lastPage) => lastPage.meta.next_page,
    select: selectionBookingRefundeds,
  })

export const getRefundedQueryOptions = (
  params: Parameters<typeof refundedService.detail>[0],
) =>
  queryOptions({
    queryKey: queryKeys.refunded.detail(params),
    queryFn: ({ signal }) => refundedService.detail(params, { signal }),
    select: selectionRefunded,
  })
